export enum NotifyGroup {
  CREATE_SUCCESS = 'Create group successfully!',
  CREATE_FALSE = 'Failed to create group. Please try again or contact admin.',
  UPDATE_SUCCESS = 'Update group successfully!',
  UPDATE_FALSE = 'Failed to update group. Please try again or contact admin.'
}

export enum GroupMemberPermission {
  VIEWER = 'Viewer',
  EDITOR = 'Editor',
  ADMIN = 'Admin',
  OWNER = 'Owner'
}
